import { useStyletron } from 'baseui';
import { Heading, HeadingLevel } from 'baseui/heading';
const ScopeCard = ({
  scope
}) => {
  const [css, theme] = useStyletron();
  return <div className={css({
    backgroundColor: theme.colors.backgroundPrimary,
    border: 'solid 1px #eee',
    borderRadius: '10px',
    padding: '1em 1.5em',
    margin: '1.0em'
  })} data-testid="scope-card">
      <Heading styleLevel={4}>{scope.name}</Heading>
      {scope.description.length > 0 ? <div dangerouslySetInnerHTML={{
      __html: scope.description
    }}></div> : <p>No description</p>}
    </div>;
};
export const ScopeList = ({
  scopes
}) => {
  const [css] = useStyletron();
  if (scopes.length === 0) return;
  return <div className={css({
    margin: '2em 0'
  })} data-testid="scope-list">
      <Heading>Scope Items</Heading>
      <HeadingLevel>
        {scopes.map(scope => <div>
            <ScopeCard key={scope.id} scope={scope} />
          </div>)}
      </HeadingLevel>
    </div>;
};
export default ScopeCard;